import { seed } from '../data/seed.js';

export const KEY='render-hub-proto-v3';

export let S;

try{const raw=localStorage.getItem(KEY);S=raw?JSON.parse(raw):null}catch(e){S=null}

if(!S||S.v!==3)S=seed();

export const save=()=>{try{localStorage.setItem(KEY,JSON.stringify(S))}catch(e){}};

export const UI={v:'today',dept:'pm',pf:'active',pq:'',ps:'all',pw:'all',po:'new',pview:'list',rc:'all',rt:'all',rs:'all',pg:'stage',pcol:{done:1},cv:false,sl:null,av:null,pr:null,aid:null,mtab:'overview',mr:30,rtab:null,rw:0,btab:'overview',ctId:null,ptab:'tasks',stab:'pipeline',ch:'general',atab:'team',nav:0,pl:{on:0,t:0,h:null},paytab:'card',modal:null};

(function(){const h=(location.hash||'').slice(1);if(['today','projects','sales','marketing','roster','board','chat','gallery','admin'].includes(h))UI.v=h})();
